import { Flex } from 'antd';

import { CustomButton } from '../../../../components';

type SubFilterFooterProps = {
  onReset: () => void;
  onApply: () => void;
};

const SubFilterFooter: React.FC<SubFilterFooterProps> = ({
  onReset,
  onApply,
}) => (
  <Flex
    style={{
      position: 'sticky',
      bottom: 0,
      padding: '8px 4px 8px',
      background: 'var(--surface-container)',
      zIndex: 2,
    }}
    justify='flex-end'
    align='center'
    gap={8}
  >
    <CustomButton
      text='Reset'
      onClick={onReset}
      width='auto'
      height='32px'
      bgColor='transparent'
      color='var(--text-primary)'
      fontSize='12px'
      fontWeight='600'
      borderRadius='0'
      boxShadow='none'
    />
    <CustomButton
      text='Apply'
      onClick={onApply}
      width='62px'
      height='32px'
      bgColor='#000'
      color='#fff'
      fontSize='12px'
      fontWeight='500'
      borderRadius='8px'
      boxShadow='0px 4px 16px 0px rgba(0, 0, 0, 0.27)'
    />
  </Flex>
);

export default SubFilterFooter;
